import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import vuetify from '@/vuetify'

Vue.config.productionTip = false

/**
 * Animations
 */
import '../node_modules/animate.css/animate.min.css'

/**
 * Axios
 */
import axios from 'axios';
Vue.prototype.$axios = axios

/**
 * Firebase
 */
// Firebase
const firebase = require("@/firebase/firebase-config.js");
Vue.prototype.$firebase = firebase;
// Firebase Auth Mixin
import firebaseAuthMixin from '@/firebase/firebase-auth-mixin.js'
Vue.use(firebaseAuthMixin)
// Firebase Firestore Mixin
import firebaseFirestoreMixin from '@/firebase/firebase-firestore-mixin.js'
Vue.use(firebaseFirestoreMixin)

/**
 * Icons
 */
import "@/assets/icons/css/styles.min.css";

/**
 * Mixins
 */
import mixin from '@/mixin.js';
Vue.use(mixin);

/**
 * Redis
 */
import redisMixin from "@/redis/redis-mixin";
Vue.use(redisMixin)

/**
 * Service Worker
 */
import './registerServiceWorker'
import sw_mixin from "@/sw_mixin";
Vue.use(sw_mixin)

/**
 * Vue2 Editor (Rich text editor)
 */
import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

/**
 * Global Components
 */
import AppBtn from "@/components/app/AppBtn";
Vue.component('AppBtn', AppBtn)

import AppIcon from "@/components/app/AppIcon";
Vue.component('AppIcon', AppIcon)

import AppInput from "@/components/app/AppInput";
Vue.component('AppInput', AppInput)

import AppText from "@/components/app/AppText";
Vue.component('AppText', AppText)

import CloseIcon from "@/components/CloseIcon";
Vue.component('CloseIcon', CloseIcon)

import ConfirmationAnimation from "@/components/ConfirmationAnimation";
Vue.component('ConfirmationAnimation', ConfirmationAnimation)

import ContactIconLink from "@/components/ContactIconLink";
Vue.component('ContactIconLink', ContactIconLink)

import DatePicker from "@/components/DatePicker";
Vue.component('DatePicker', DatePicker)

import DeleteIcon from "@/components/DeleteIcon";
Vue.component('DeleteIcon', DeleteIcon)

import EditIcon from "@/components/EditIcon";
Vue.component('EditIcon', EditIcon)

import ExpansionPanel from "@/components/ExpansionPanel";
Vue.component('ExpansionPanel', ExpansionPanel)

import FormBtn from "@/components/FormBtn";
Vue.component('FormBtn', FormBtn)

import IconWithLabel from "@/components/IconWithLabel";
Vue.component('IconWithLabel', IconWithLabel)

import ImageUpload from "@/components/ImageUpload";
Vue.component('ImageUpload', ImageUpload)

import LoadingAnimation from "@/components/LoadingAnimation";
Vue.component('LoadingAnimation', LoadingAnimation)

import NewCopyIcon from "@/components/NewCopyIcon";
Vue.component('NewCopyIcon', NewCopyIcon)

import SideBySideBulletPoints from "@/components/SideBySideBulletPoints";
Vue.component('SideBySideBulletPoints', SideBySideBulletPoints)

import TimePicker from "@/components/TimePicker";
Vue.component('TimePicker', TimePicker)

import TitledPageBreak from "@/components/TitledPageBreak";
Vue.component('TitlePageBreak', TitledPageBreak)

let app
firebase.auth.onAuthStateChanged(currentUser => {
	if (!app) {
		app = new Vue({
			router,
			vuetify,
			render: h => h(App)
		}).$mount('#app')
	}
})
